export const GeneratedProposalLogLocale = {
  en: {
    branch: 'Branch',
    staff_id: 'Staff ID',
    proposal_name: 'Proposal Name',
    proposal_id: 'Proposal ID',
    generated_at: 'Generated At',
    generated_by: 'Generated By',
    business_group: 'Business Group',
    shared_to_type: 'Shared To Type',
    shared_to_name: 'Shared To Name',
    shared_to_id: 'Shared To ID',
    proposal_type: 'Proposal Type',
    proposal_mode: 'Proposal Mode',
    unit_ref_numbers: 'Unit Reference Numbers',
    property_names: 'Property Names',
    platform: 'Platform',
    team: 'Team',
  },
  ar: {
    branch: 'الفرع',
    staff_id: 'معرف الموظف',
    proposal_name: 'اسم العرض',
    proposal_id: 'رقم العرض',
    generated_at: 'تاريخ الإنشاء',
    generated_by: 'تم الإنشاء بواسطة',
    business_group: 'المجموعة التجارية',
    shared_to_type: 'نوع الشخص المشترك معه',
    shared_to_name: 'الاسم المشترك معه',
    shared_to_id: 'رقم المعرّف للمشترك معه',
    proposal_type: 'نوع العرض',
    proposal_mode: 'وضع العرض',
    unit_ref_numbers: 'أرقام الوحدات المرجعية',
    property_names: 'أسماء العقارات',
    team: 'الفريق',
    platform: 'المنصة',
  },
};

export const GeneratedProposalLogLocalePath = 'GeneratedProposalLog';
